import { IVesselActivity, VesselStopTypeForStepper, IVesselMovement, VesselActivityHelper, IVesselTransitStatus } from "@pmis3/vessel-activity-core";
import { IStepperStep } from "./data/stepperStep";

export class VesselVisitStepperHelper {
    static calculateSteps(vesselActivities: IVesselActivity[], statuses: IVesselTransitStatus[], addButtonVisible: boolean) {
        let statusOfPreviousMovement: string | undefined;

        const steps = vesselActivities.flatMap((va, i) => {
            const stopType = VesselActivityHelper.getStopType(vesselActivities, i);
            const isStop = stopType !== null
            const indexOfPreviousStop = i > 0 ? i - 1 : null;
            const isActive = !va.isDeleted;

            if (!isActive) return [];

            if (isStop) {
                const label = stopType;
                const text = va.startLocation?.shortCode ?? "";
                const result: IStepperStep[] = [];
                const arrivalMovementToStop = VesselActivityHelper.getArrivalMovementToStop(i, vesselActivities);
                // const stopNumber = VesselActivityHelper.getStopNumber(vesselActivities, i);

                // if (stopType === VesselStopTypeForStepper.Departure) {
                // 	result.push({ label: 'icon', text: 'Add a move', visible: addButtonVisible, indexInArray: i });
                // 	text = "Dep";
                // }

                if (stopType !== VesselStopTypeForStepper.Departure)
                    result.push({ 
                        label, 
                        text, 
                        visible: true, 
                        indexInArray: i, 
                        arrivalMovementToStop: arrivalMovementToStop, 
                        // stopNumber: stopNumber, 
                        stop: va, 
                        status: statusOfPreviousMovement 
                });

                const isLast = i === vesselActivities.length - 1;
                if (isLast) {
                    // const visibilityOfLastAddButton = stopType !== VesselStopTypeForStepper.Departure ? addButtonVisible : false;
                    result.push({ 
                        label: 'icon', 
                        text: 'Add a move', 
                        visible: addButtonVisible, 
                        indexInArray: i, 
                        status: statusOfPreviousMovement 
                    });
                }

                return result;
            } else {
                statusOfPreviousMovement = statuses.find(status => status.id == (va as IVesselMovement).statusId)?.name;

                if (!addButtonVisible) {
                    return [{ label: 'icon', text: 'Add a move', visible: addButtonVisible, indexInArray: i }]
                }
                const visible = true;
                // const nextVesselStopExists = i + 1 < vesselActivities.length;
                // const nextStopIndex = i + 1;
                // const nextStop = nextVesselStopExists ? vesselActivities[nextStopIndex] : null;

                // if (i == 0 && nextStop) {
                //     visible = nextStop.status != VesselTransitStatus.Completed;
                // }
                // else if (i != 0 && nextStop) {
                //     const prevStop = vesselActivities[i - 1];
                //     visible = prevStop.status != VesselTransitStatus.Completed && nextStop.status != VesselTransitStatus.Completed;
                // }
                return [{ label: 'icon', text: 'Add a move', visible: visible, indexInArray: i, indexOfPreviousStop: indexOfPreviousStop }];
            }
        });

        if (steps.length === 0) {
            const addButtonWhenActivitiesArrayIsEmpty = { label: 'icon', text: 'Add a move', visible: addButtonVisible, indexInArray: 0 };
            steps.push(addButtonWhenActivitiesArrayIsEmpty);
        }

        return steps;
    }

    static timeIsInvalid(time: Date | null, before?: Date | null, after?: Date | null): boolean {
        if (!time) return true;

        const isAfter = !before || time > before;
        const isBefore = !after || time < after;

        return !isAfter || !isBefore;
    }

    static calculateProgressForActivities(activities: IVesselActivity[], now: Date = new Date()): IVesselActivity[] {
        return activities.map(activity => {

            /** The start time is the departure time for the previous stop and the end time is the arrival time for the next stop. */
            const startTime = activity.startTime ?? activity.estimatedStartTime;
            const endTime = activity.endTime ?? activity.estimatedEndTime;
            let differenceActualEstimatedDeparture = 0;
            let differenceActualEstimatedArrival = 0;
            let differenceBetweenDepartureAndArrival = 0;

            if (!endTime || !startTime) {
                return { ...activity, progressPercentEstimate: undefined };
            }

            if (now > endTime) {
                return { ...activity, progressPercentEstimate: 100 };
            }

            /**
             * if difference is negative, the vessel left earlier than expected
             * if difference is positive, the vessel left later than expected
             * if difference is zero, the vessel left on time
             */
            if (activity.startTime?.getTime() && activity.estimatedStartTime?.getTime()) {
                differenceActualEstimatedDeparture = (activity.startTime.getTime() - activity.estimatedStartTime.getTime()) / 60000; // convert ms to minutes
            }

            if (activity.endTime?.getTime() && activity.estimatedEndTime?.getTime()) {
                differenceActualEstimatedArrival = (activity.endTime.getTime() - activity.estimatedEndTime.getTime()) / 60000; // convert ms to minutes

                /**
                 * if this is = 0, no delay or early during movement
                 * if this is > 0, there was a delay during movement
                 * if this is < 0, the movement took less time than expected
                 */
                differenceBetweenDepartureAndArrival = differenceActualEstimatedArrival - differenceActualEstimatedDeparture;
            }

            const total = endTime.getTime() - startTime.getTime();
            const elapsed = now.getTime() - startTime.getTime();

            const percent = Math.min(100, Math.max(0, (elapsed / total) * 100));

            return { ...activity, progressPercentage: percent, departureDifference: differenceActualEstimatedDeparture, arrivalDifference: differenceBetweenDepartureAndArrival };
        });
    }
}
